export default __webpack_public_path__ + "static/logo-colored-seo-logotext-0995812b2421a431e5bba487d9eb49de.png";